/**
 * Файлы из `DataTransfer` — буфера обмена (paste) или перетаскивания (drop).
 *
 * Print Screen и «Копировать изображение» кладут скриншот и в `files`, и в
 * `items` с `kind === 'file'` — читаем только один источник, иначе один и тот
 * же файл ушёл бы на загрузку дважды. Обратный случай тоже бывает: Firefox при
 * перетаскивании картинки из другой вкладки заполняет `items`, но не `files`,
 * поэтому одного `files` мало. Текст лежит в `items` с `kind === 'string'` и
 * сюда не попадает.
 */
export function extractDataTransferFiles(data: DataTransfer | null): File[] {
  if (!data) return []
  if (data.files?.length) return Array.from(data.files)
  if (!data.items) return []
  return Array.from(data.items)
    .filter((item) => item.kind === 'file')
    .map((item) => item.getAsFile())
    .filter((file): file is File => file !== null)
}
